import { Children, createContext, useContext, useEffect, useMemo, useRef, useState } from "react";
import auth0 from "auth0-js";
import { useNavigate } from "react-router-dom";
import { IApiLoginResponse, IApiLoginResponseOrganization } from "../models/api/login/IApiLoginResponse";
import { LoginWithCenteredForm } from "../components/LoginWithCenteredForm/LoginWithCenteredForm";
import {
    Divider,
    Button,
    Image,
    Container,
    Spinner,
    FormControl,
    FormLabel,
    Heading,
    HStack,
    ListItem,
    Input,
    List,
    Alert,
    AlertIcon,
    AlertTitle,
    Link,
    Stack,
    Text,
    useBreakpointValue,
    useColorModeValue,
  } from '@chakra-ui/react'
import { Logo } from "../components/LoginWithCenteredForm/Logo";
import Helpers from '../Helpers';
import { ZitadelContext } from "./ZitadelProvider";
import { IAuthOrganizationEntry } from "../models/auth/IAuthOrganizationEntry";

interface IOrganizationContext {
    available: IAuthOrganizationEntry[]
    selected: IAuthOrganizationEntry;
    setSelected: React.Dispatch<React.SetStateAction<IAuthOrganizationEntry | undefined>>;
    //getOrganizationId(): string;
}
    
export const OrganizationContext = createContext({} as IOrganizationContext);

export const OrganizationProvider = (props: { 
    children: React.ReactElement 
}) => {

    const [available, setAvailable] = useState<IAuthOrganizationEntry[]>([]);
    const [selected, setSelected] = useState<IAuthOrganizationEntry | undefined>(undefined);

    const { user } = useContext(ZitadelContext);
    
    var organizations: IAuthOrganizationEntry[] = JSON.parse(window.atob((user.profile["urn:zitadel:iam:user:metadata"] as any).organizations as string));
    //console.log(organizations)

    if(selected != null) {
        return (
        <OrganizationContext.Provider
            value={{
                available,
                selected,
                setSelected
            }}
        >
            {props.children}
        </OrganizationContext.Provider>
        ); 
    } else if(organizations.length === 0) {
        return <div>Error! Organization not found!</div>;
    } else {
        setAvailable(organizations);
        setSelected(organizations[0]);
        return <div>Loading...</div>;
    }
}